<script setup lang="ts">
// Root component — Vuetify <v-app> + router-view. Тема ставится здесь, а не в
// AppLayout: /login живёт вне layout и тоже должен слушать системную тему.
import { installAppTheme } from '@/composables/useAppTheme'

installAppTheme()
</script>

<template>
  <VApp>
    <RouterView />
  </VApp>
</template>
